const env = process.env;

const fallbackBranches = [
  {
    city: 'Ahmedabad',
    address:
      '522, Palladium Business Hub, Near Engineering Collage, Opp. 4D Square Mall, Sarkhej - Gandhinagar Highway, Motera, Ahmedabad, Gujarat 380005',
    phone: '+91 9327001903'
  },
  {
    city: 'Baroda',
    address:
      '501, Kalash Complex, Muktanand Cir, Kalyan Nagar, Karelibagh, Vadodara, Gujarat 390008',
    phone: '+91 9998816058'
  },
  {
    city: 'Anand',
    address:
      '307, Nilkanth Varni, Opp. Akruti Nagar, Jitodia Road, Anand 388001',
    phone: '+91 7874430009'
  }
];

const parseBranches = () => {
  try {
    if (env.REACT_APP_BRANCHES_JSON) {
      const parsed = JSON.parse(env.REACT_APP_BRANCHES_JSON);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (error) {
    console.warn('Invalid REACT_APP_BRANCHES_JSON value', error);
  }

  return fallbackBranches;
};

export const siteConfig = {
  backendUrl: env.REACT_APP_BACKEND_URL || 'http://localhost:8000',
  companyName: env.REACT_APP_COMPANY_NAME || 'Smart Automation and LV System Pvt. Ltd.',
  companyShortName: env.REACT_APP_COMPANY_SHORT_NAME || 'Smart Automation & LV Systems Pvt Ltd',
  companyTagline:
    env.REACT_APP_COMPANY_TAGLINE || 'Intelligent Automation. Secure Connectivity. Smarter Living.',
  companyDescription:
    env.REACT_APP_COMPANY_DESCRIPTION || 'Advanced Smart Automation and Low Voltage Solutions for Modern Spaces.',
  companyAddress:
    env.REACT_APP_COMPANY_ADDRESS ||
    '522 Palladium Business Hub, Near Engineering Collage, Opp. 4D Square Mall, Sarkhej - Gandhinagar Hwy, Motera, Ahmedabad, Gujarat 382424',
  companyPhone: env.REACT_APP_COMPANY_PHONE || '+91 9327001903',
  companyEmail: env.REACT_APP_COMPANY_EMAIL || 'tech@smartautomation.co.in',
  companyWhatsapp: env.REACT_APP_COMPANY_WHATSAPP || '+919327001903',
  footerLogoUrl:
    env.REACT_APP_FOOTER_LOGO_URL ||
    'https://customer-assets.emergentagent.com/job_automation-nexus-6/artifacts/8a55j6ou_image.png',
  smartPowerControlsUrl: env.REACT_APP_SMART_POWER_CONTROLS_URL || 'https://smartpowercontrols.in/',
  socialLinks: {
    facebook: env.REACT_APP_FACEBOOK_URL || 'https://facebook.com',
    twitter: env.REACT_APP_TWITTER_URL || 'https://twitter.com',
    linkedin: env.REACT_APP_LINKEDIN_URL || 'https://linkedin.com',
    instagram: env.REACT_APP_INSTAGRAM_URL || 'https://instagram.com'
  },
  branches: parseBranches()
};
